import { MessageCircle } from "lucide-react";

const PHONE = "13522325546"; // E.164 without +, country code 1 (US)
const PREFILL = encodeURIComponent("Hi James — I came from your site and would like to connect.");

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${PREFILL}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg shadow-charcoal/30 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
      style={{ borderRadius: "999px" }}
    >
      <span className="relative flex items-center justify-center w-9 h-9 bg-white/15 rounded-full">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping opacity-60" />
        <MessageCircle className="w-5 h-5 relative" strokeWidth={2} />
      </span>
      <span className="text-[12px] uppercase tracking-widest-custom font-medium hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
